var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.950994 15H10.1271V13.4375H3.36577V13.3239L6.63281 9.82955C9.13281 7.15199 9.87145 5.90199 9.87145 4.28977C9.87145 2.04545 8.05327 0.255681 5.49645 0.255681C2.94673 0.255681 1.00781 1.98864 1.00781 4.54545H2.68395C2.68395 2.89062 3.75639 1.78977 5.43963 1.78977C7.01634 1.78977 8.22372 2.75568 8.22372 4.28977C8.22372 5.6321 7.43537 6.62642 5.75213 8.46591L0.950994 13.7216V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoWhite);
export default __webpack_public_path__ + "static/media/two-white.55e7decc8d15d6944309dde559329b5e.svg";
export { ForwardRef as ReactComponent };